import React from 'react';
import WithFlow from 'conversie-flow-bundle/assets/js/components/flow/WithFlow';

/* Icons */
import closeIcon from 'symbols/close.svg';

/* Atoms */
import { Icon } from "js/components/atoms";

/* Utilities */
import { trans, addScrollPadding, removeScrollPadding } from 'js/utilities';
import ConversionFlowSteps from "js/components/ConversionFlow/components/ConversionFlowSteps";
import ConversionFlowUsps from "js/components/ConversionFlow/components/ConversionFlowUsps";
import {saveShopData} from "../../../utilities/shopStorage";

export default class ConversionFlowOverlay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: props.open ? 'open' : 'closed',
            flowUrl: props.flowUrl
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.open !== prevProps.open) {
            this.setState({
                open: this.props.open ? 'opening' : 'closing'
            }, () => {
                if (this.props.open) {
                    addScrollPadding();
                    document.body.classList.add('overflow-hidden');
                } else {
                    removeScrollPadding();
                    document.body.classList.remove('overflow-hidden');
                }

                setTimeout(() => {
                    this.setState({ open: this.props.open ? 'open' : 'closed' });
                }, 300);
            });
        }
    }

    render() {
        if (this.state.open === 'closed') return null;

        const { handleClose, overlayBody, usps } = this.props;

        let flowUrl = this.props.flowUrl;
        if (this.props?.addConversionParam) {
            flowUrl += '&conversion=1';
        }
        if (this.props?.sourceFlow) {
            flowUrl += '&source_flow=' + encodeURIComponent(this.props.sourceFlow);
        }

        return (
            <div
                className={`flow-overlay ${this.state.open}`}
            >
                <WithFlow
                    flowUrl={flowUrl}
                    flow={null}
                    translate={trans}
                >
                    {(passProps) => {
                        const { flow, setStep } = passProps;

                        if (flow?.steps?.find((step) => step.active)?.last) {
                            saveShopData('sw-context-token', '');
                        }

                        return (
                            <div className="container d-flex flex-column h-100">
                                <div className="px-6 py-3 flow-header bust-out bg-white d-flex justify-content-between align-items-center">
                                    <div className="font-weight-bold text--14 line-height-20">
                                        {flow?.form?.title || '\u00A0' }
                                    </div>
                                    <button className="modal__close close" title={trans('modal.close.title')} aria-label={trans('modal.close.title')} onClick={handleClose}>
                                        <Icon url={closeIcon.url} size={24} />
                                    </button>
                                </div>
                                <div className="flow-navigation">
                                    <ConversionFlowSteps
                                        steps={flow?.steps}
                                        setStep={setStep}
                                    />
                                </div>
                                <div className="flow-overlay__body pb-14 pb-xl-20">
                                    {overlayBody(passProps)}
                                    <div className="row">
                                        <div className="col-12 col-xl-11">
                                            <ConversionFlowUsps
                                                usps={usps}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }}
                </WithFlow>
            </div>
        )
    }
}
